var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-modal",
    {
      staticClass: "supervised-person-manager-modal",
      attrs: { size: "tiny", closable: false },
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _c(
        "sui-modal-header",
        { staticClass: "supervised-person-manager-modal-header" },
        [_vm._v(" " + _vm._s(_vm.modalHeaderContent) + " ")]
      ),
      _c(
        "sui-modal-content",
        [
          _c(
            "sui-form",
            [
              _c("sui-form-field", [
                _c("label", [_vm._v("Supervised person email address")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.person.email,
                      expression: "person.email",
                      modifiers: { trim: true },
                    },
                  ],
                  attrs: {
                    placeholder: "Enter email of supervised person user",
                  },
                  domProps: { value: _vm.person.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.person, "email", $event.target.value.trim())
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
              _c(
                "sui-form-fields",
                { attrs: { grouped: "" } },
                [
                  _c("label", [_vm._v("Supervised person submits:")]),
                  _c(
                    "sui-form-field",
                    [
                      _c("sui-checkbox", {
                        attrs: { label: "Personal securities" },
                        model: {
                          value: _vm.person.has_to_submit_personal_securities,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.person,
                              "has_to_submit_personal_securities",
                              $$v
                            )
                          },
                          expression:
                            "person.has_to_submit_personal_securities",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "sui-form-field",
                    [
                      _c("sui-checkbox", {
                        attrs: { label: "Outside business activities" },
                        model: {
                          value:
                            _vm.person
                              .has_to_submit_outside_business_activities,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.person,
                              "has_to_submit_outside_business_activities",
                              $$v
                            )
                          },
                          expression:
                            "person.has_to_submit_outside_business_activities",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "sui-form-field",
                    [
                      _c("sui-checkbox", {
                        attrs: { label: "Political contributions" },
                        model: {
                          value:
                            _vm.person.has_to_submit_political_contributions,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.person,
                              "has_to_submit_political_contributions",
                              $$v
                            )
                          },
                          expression:
                            "person.has_to_submit_political_contributions",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "sui-modal-actions",
        [
          _c("sui-button", {
            attrs: {
              basic: "",
              size: "small",
              color: "grey",
              type: "button",
              content: "Cancel",
            },
            on: { click: _vm.cancel },
          }),
          _c("sui-button", {
            attrs: {
              primary: "",
              size: "small",
              type: "button",
              content: "Save",
            },
            on: { click: _vm.handleSave },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }